var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8621 4.75863V2H2V18.8966C2 20.6078 3.39223 22 5.10344 22H18.8965C20.6078 22 22 20.6078 22 18.8966V4.75863H17.8621ZM15.1034 17.1724H4.75863V15.1034H15.1035V17.1724H15.1034ZM15.1034 13.0345H4.75863V10.9655H15.1035V13.0345H15.1034ZM15.1034 6.82758V8.89656H4.75863V6.82758V4.75863H15.1035V6.82758H15.1034ZM19.931 18.8966C19.931 19.467 19.467 19.9311 18.8965 19.9311C18.3261 19.9311 17.862 19.467 17.862 18.8966V6.82758H19.931V18.8966Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default ForwardRef;